const blogButtonContainer = document.querySelector('[data-behaviour="blog-post-load-more-show"]');
let loadMoreButton = document.querySelector('[data-behaviour="blog-post-load-more"]');
const featuredPost = document.querySelector('[data-featured-id]');
const featuredPostID = featuredPost ? featuredPost.dataset.featuredId : null;

if (blogButtonContainer) {
  blogButtonContainer.style.display = "flex";
}

if (loadMoreButton) {
	// Elements
	const section = loadMoreButton.closest('[data-ref="blog-post-list"]');
	const inner = section.querySelector('[data-ref="blog-post-inner"]');
	// Text
	const loadingSpan = '<span>.</span><span>.</span><span>.</span>'
	const loadingText = 'Loading' + loadingSpan;
	const defaultButtonText = 'Load more';
	//active nav
	let activeNav = section.querySelector('[data-active="1"]');

	loadMoreButton.addEventListener('click', () => {
		//Disable Button
		loadMoreButton.disabled = true;
		loadMoreButton.innerHTML = loadingText;
		//Form Vars
		let activeKey = activeNav.dataset.key;
		let paged = loadMoreButton.dataset.paged;

		fetchBlogPosts(activeKey, paged, featuredPostID)
			.then(response => {
				if (response.status === 'success' && response.html) {
					inner.innerHTML += response.html;

					if (response.data &&
						!response.data.pagination
					) {
						loadMoreButton.classList.add('blog-post-list__button--hidden');
						loadMoreButton.dataset.paged = 1;
					} else {
						loadMoreButton.dataset.paged = Number(loadMoreButton.dataset.paged) + 1;
						loadMoreButton.classList.remove('blog-post-list__button--hidden');
					}

				} else {
					console.log('Error during fetch response');
				}

				loadMoreButton.disabled = false;
				loadMoreButton.innerHTML = defaultButtonText;
			})
			.catch(error => {
				console.log('Error during fetch: ' + error);
			});
	});
};

let filters = document.querySelectorAll('[data-behaviour="blog-post-filter"]');
if (filters.length) {
	// Elements
	const section = filters[0].closest('[data-ref="blog-post-list"]');
	const inner = section.querySelector('[data-ref="blog-post-inner"]');

	filters.forEach(filter => {
		filter.addEventListener('click', () => {
			//disabled buttons
			filters.forEach(button => {
				button.disabled = true;
			});

			//Form Els
			const paged = 1; // will always be 1 on first click
			let activeNav = section.querySelector('[data-active="1"]');
			let activeKey = filter.dataset.key;

			loadMoreButton.dataset.paged = 2; //paged to go towards 1 + 1

			fetchBlogPosts(activeKey, paged, featuredPostID)
				.then(response => {
					if (response.status === 'success' && response.html) {
						inner.innerHTML = response.html;

						if (response.data &&
							!response.data.pagination
						) {
							loadMoreButton.classList.add('blog-post-list__button--hidden');
						} else {
							loadMoreButton.classList.remove('blog-post-list__button--hidden');
						}

						activeNav.dataset.active = 0;
						activeNav.classList.remove('button--active');

						filter.dataset.active = 1;
						filter.classList.add('button--active');

					} else {
						console.log('Error during fetch response');
					}

					//enable buttons
					filters.forEach(button => {
						button.disabled = false;
					});
				})
				.catch(error => {
					console.log('Error during fetch: ' + error);
				});
		})
	});

	const selectFilter = document.querySelector('[data-select="blog-filter"]');
	if (selectFilter) {
		selectFilter.addEventListener('change', (e) => {
			let activeKey = e.target.value; //category id
			const paged = 1; // will always be 1 on first click

			fetchBlogPosts(activeKey, paged, featuredPostID)
				.then(response => {
					if (response.status === 'success' && response.html) {
						inner.innerHTML = response.html;

						if (response.data &&
							!response.data.pagination
						) {
							loadMoreButton.classList.add('blog-post-list__button--hidden');
						} else {
							loadMoreButton.classList.remove('blog-post-list__button--hidden');
						}
						let activeNav = section.querySelector('[data-active="1"]');
						activeNav.dataset.active = 0;
						activeNav.classList.remove('button--active');
						//button on nav
						let getFilterNav =  section.querySelector(`[data-key="${activeKey}"]`)//just in case resize
						getFilterNav.dataset.active = 1;
						getFilterNav.classList.add('button--active');

					} else {
						console.log('Error during fetch response');
					}
				})
				.catch(error => {
					console.log('Error during fetch: ' + error);
				});

		});
	}
}



/**
 * fetchBlogPosts
 * @param {Number} activeKey TermId
 * @param {Number} paged Default 1
 * @returns JSON response (Blog Posts)
 */
 const fetchBlogPosts = async ( activeKey, paged = 1, exclude = '' ) => {
	// FORM
	const formData = new FormData();
	formData.set('security', wp_ajax.security);
	formData.set('activeKey', activeKey);
	formData.set('paged', paged);

	if (exclude) {
		formData.set('exclude', exclude);
	}
	const response = await fetch(`${wp_ajax.ajax_url}?action=blog_post_load_more`, {
		method: 'POST',
		body: formData
	})

	if (!response.ok) {
		const message = `An error has occured: ${response.status}`;
		throw new Error(message);
	}

	const blogs = await response.json();

  	return blogs;
}
